<template>
  <!-- 添加图文直播 -->
  <div class="topicAdd">
    <div class="add_box">
      <el-form
        :model="toAdDas"
        :rules="toAdRule"
        label-position="right"
        label-width="200px"
        ref="ruleForm"
        style="width: 90%; margin: 20px auto"
      >
        <el-row>
          <el-col>
            <el-form-item label="标题" prop="title">
              <el-input
                placeholder="请输入内容"
                v-model="toAdDas.title"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="摘要" prop="zhaiyao">
              <el-input
                placeholder="请输入内容"
                v-model="toAdDas.zhaiyao"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="类型" prop="type">
              <el-select v-model="toAdDas.type" clearable placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="时间" prop="createDate">
              <el-date-picker
                v-model="toAdDas.createDate"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="封面图(750*419)" prop="coverImg" ref="coverImg">
              <el-upload
                class="avatar-uploader"
                :action="serverUrl"
                :headers="header"
                name="img"
                :auto-upload="true"
                :show-file-list="false"
                :on-success="upSuccess"
              >
                <img
                  v-if="toAdDas.coverImg"
                  :src="toAdDas.coverImg"
                  class="avatar"
                  style="width: 150px; height: auto"
                />

                <i
                  :class="
                    loadUpt
                      ? 'el-icon-loading'
                      : 'el-icon-plus avatar-uploader-icon'
                  "
                  style="margintop: 10px; font-size: 50px"
                  v-else
                ></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="频道" prop="menuId">
              <el-select
                placeholder="请选择"
                v-model="toAdDas.menuId"
                clearable
              >
                <el-option
                  v-for="item in menuDas"
                  :key="item.id"
                  :label="item.menuName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <el-form-item label="信息流位置 " prop="menuId">
              <el-select
                placeholder="请选择"
                v-model="toAdDas.location"
                clearable
              >
                <el-option
                  v-for="item in locationItem"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-button
            style="margin-left: 200px; margin-top: 50px"
            type="primary"
            @click="submitAdd('ruleForm')"
            >保存</el-button
          >
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import { baseURL } from "../../api/config";
export default {
  props: ["AddData"],
  data() {
    var valiIcon = (rule, value, callback) => {
      // 图片验证
      // alert(this.$refs.coverImg)
      if (this.toAdDas.coverImg == "") {
        callback(new Error("封面图不能为空"));
      } else {
        callback("");
      }
    };
    return {
      loadUpt: false, //加载
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
      options: [
        {
          value: "0",
          label: "党建图文",
        },
        {
          value: "1",
          label: "直播图文",
        },
      ],
      locationItem: [
        {
          value: "1",
          label: "第一信息流",
        },
        {
          value: "2",
          label: "第二信息流",
        },
        {
          value: "3",
          label: "第三信息流",
        },
        {
          value: "4",
          label: "第四信息流",
        },
        {
          value: "5",
          label: "第五信息流",
        },
        {
          value: "6",
          label: "第六信息流",
        },
        {
          value: "7",
          label: "第七信息流",
        },
        {
          value: "8",
          label: "第八信息流",
        },
        {
          value: "9",
          label: "第九信息流",
        },
        {
          value: "10",
          label: "第十信息流",
        },
      ],
      value: [],
      menuDas: [],
      //添加的参数：
      toAdDas: {
        title: "", // 标题
        zhaiyao: "", //摘要
        coverImg: "", //封面图
        createDate: "", //创建时间
        type: "", //分类
      },

      toAdRule: {
        title: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        zhaiyao: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        createDate: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        coverImg: [{ required: true, validator: valiIcon, trigger: "blur" }],
        type: [{ required: true, message: "内容不能为空", trigger: "change" }],
      },
    };
  },
  methods: {
    //将中国标准时间转换为年月日格式  ----开始
    formatTen(num) {
      return num > 9 ? num + "" : "0" + num;
    },
    formatDate(date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      return year + "-" + this.formatTen(month) + "-" + this.formatTen(day)+ " " + this.formatTen(hour)+ ":" + this.formatTen(minute)+ ":" + this.formatTen(second);
    },
    //新增：
    submitAdd(formName) {
      var time = this.formatDate(new Date(this.toAdDas.createDate));
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.postAxios("/broadcast/add", {
              title: this.toAdDas.title, //标题
              coverImg: this.toAdDas.coverImg, //封面图
              zhaiyao: this.toAdDas.zhaiyao, //摘要
              createDate: time, //时间
              type: this.toAdDas.type, //类型
              menuId: this.toAdDas.menuId, //频道
              location: this.toAdDas.location, //信息楼
            }).then((res) => {
              if (res.success == true) {
                this.$router.push({ path: "/broadCast" });
                this.$message.success(res.message);
              } else if (res.success == false) {
                this.$message.error(res.message);
              } else if (!res.success && res.statusCode == "401") {
                this.$message.error(res.message);
                this.$router.push("/");
              }
            });
          } else {
            return false;
          }
        });
    },
    // 头像上传成功
    upSuccess(file) {
      this.toAdDas.coverImg = file.entity;
    },
    //频道下拉框数据：
    getPosition() {
      this.getAxios("/menu/list").then((res) => {
        if (res.success == true) {
          this.menuDas = res.content;
        }
        if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
  },
  mounted() {
    this.getPosition();
  },
};
</script>
<style scoped lang="less">
.topicAdd {
  width: 100%;
  height: 100%;
  .add_box {
    width: 95%;
    height: 100%;
    margin: 0 auto;
    /deep/ .el-upload {
      width: 200px;
      height: auto;
      display: inline-block;
      text-align: center;
      cursor: pointer;
      outline: 0;
      border: 2px dashed #eee;
      img {
        width: 100%;
        height: auto;
      }
    }
    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
    }
  }
}
</style>